export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen pt-32 pb-20 px-20 max-w-[1440px] mx-auto">
      <div className="flex items-center gap-16 min-h-[calc(100vh-200px)]">
        <div className="w-[45%] space-y-12">
          <p className="text-[11px] uppercase tracking-[2px] font-light text-[#C9A961]">
            iOS DEVELOPMENT EXPERTS
          </p>
          
          <div className="space-y-2">
            <h2 className="text-[72px] leading-[0.95] font-serif text-white">
              Modern Applications
            </h2>
            <h3 className="text-[68px] leading-[0.95] font-light text-white">
              for iOS Platform
            </h3>
            <h4 className="text-[64px] leading-[0.95] font-serif italic bg-gradient-to-b from-white to-[#CCCCCC] bg-clip-text text-transparent">
              Built with Precision
            </h4>
          </div>
          
          <p className="text-lg leading-relaxed text-[#9E9E9E] max-w-[480px]">
            A team of experts developing modern applications for the iOS platform. Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices.
          </p>
        </div>
        
        <div className="w-[55%] flex items-center justify-center">
          <div className="relative w-full h-[600px] rounded-[32px] bg-gradient-to-br from-[#1A1A2E] to-[#0F0F1F] overflow-hidden">
            <div className="absolute inset-0 flex items-center justify-center">
              <img 
                src="https://public.readdy.ai/ai/img_res/1fd9c7bca95c303aa5cb38f355fb0ab0.jpg"
                alt="iOS Development Visualization"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F1F]/80 to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
